import React, { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { AppRoutes } from './routes';

const withAuth = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const WithAuth: React.FC<P> = (props) => {
    const authService = useAuth();

    return authService.getCurrentUser() ? (
      <WrappedComponent {...props} />
    ) : (
      <Navigate to={AppRoutes.LOGIN} />
    );
  };

  return WithAuth;
};

export default withAuth;
